<template>
  <div class="objects-select-input clearfix">
    <div class="form-group">
      <label class="col-sm-4 control-label">{{ field.label }}</label>
      <div class="col-sm-8">
        <select :name="field.name+'[]'" class="form-control" v-model="field.value" multiple v-el:dropdown style="width:100%;">
          <option v-for="object in field.objects" :value="object.uuid" :data-icon="object[field.iconName]" :data-label="object[field.labelName]">{{ object[field.objectName] }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectsSelectInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'objectsSelect',
          objectName: 'name',
          value: [],
          objects: []
        }
      }
    }
  },
  ready () {
    function template (data) {
      if (data.id) {
        if (data.element.attributes['data-icon']) {
          return $(`<span><span class="fa fa-cc-${data.element.attributes['data-icon'].value}"></span> ${data.text}</span>`)
        }
        if (data.element.attributes['data-label']) {
          let num = data.element.attributes['data-label'].nodeValue.charCodeAt(0) % 5
          let label = 'label-default'
          switch (num) {
            case 0:
              label = 'label-success'
              break
            case 1:
              label = 'label-primary'
              break
            case 2:
              label = 'label-danger'
              break
            case 3:
              label = 'label-info'
              break
            case 4:
              label = 'label-warning'
              break
            default:
              label = 'label-default'
              break
          }
          return $(`<span>${data.text} <label class="label label-margin ${label}">${data.element.attributes['data-label'].nodeValue}</label></span>`)
        }
      }
      if (data.title) {
        return data.text + data.title
      } else {
        return data.text
      }
    }
    $(this.$els.dropdown).select2({
      templateResult: template,
      templateSelection: template,
      minimumResultsForSearch: 10
    })
    $(this.$els.dropdown).on('select2:select', e => {
      if (this.field.value.indexOf(e.params.data.id) === -1) {
        this.field.value.push(e.params.data.id)
      }
    })
    $(this.$els.dropdown).on('select2:unselect', e => {
      if (this.field.value.indexOf(e.params.data.id) !== -1) {
        this.field.value.splice(this.field.value.indexOf(e.params.data.id), 1)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// ObjectsSelectInput.vue?1cc10b5a